import { IPromise } from 'angular';
import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';
import { BankFeedRuleDTO } from '../../../app/banking/data/dtos/bank-feed-rules/bank-feed-rule-dto';
import { BankFeedRuleSaveDTO } from '../../../app/banking/data/dtos/bank-feed-rules/bank-feed-rule-save-dto';
import { BankFeedRuleExecutionResultDTO } from '@root/app/banking/data/dtos/bank-feed-rule-result-dto';

const actions = {
    getBankFeedRules: {
        method: 'GET',
        url: `${BASE_PATH_API}/bankAccounts/:bankGlAccountId/bankFeedRules`,
    },
    createBankFeedRule: {
        method: 'POST',
        url: `${BASE_PATH_API}/bankAccounts/:bankGlAccountId/bankFeedRules`
    },
    updateBankFeedRule: {
        method: 'PUT',
        url: `${BASE_PATH_API}/bankAccounts/:bankGlAccountId/bankFeedRules/:bankFeedRuleId`
    },
    deleteBankFeedRule: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/bankAccounts/:bankGlAccountId/bankFeedRules/:bankFeedRuleId`
    },
    getBankFeedRuleExecutionResults: {
        method: 'GET',
        url: `${BASE_PATH_API}/bankAccounts/:bankGlAccountId/bankFeedRules/results`
    },
    reprioritizeBankFeedRules: {
        method: 'POST',
        url: `${BASE_PATH_API}/bankAccounts/:bankGlAccountId/bankFeedRules/reprioritizeRequest`
    },
    getBankFeedRulesCount: {
        method: 'HEAD',
        url: `${BASE_PATH_API}/bankAccounts/:bankGlAccountId/bankFeedRules`,
        transformResponse: (data, headers) => {
            return parseInt(headers.get('x-total-count'), 10);
        }
    }
};

export interface IBankFeedRulesApi {
    getBankFeedRules(searchParams: any): IPromise<BankFeedRuleDTO[]>;
    createBankFeedRule(body: BankFeedRuleSaveDTO): IPromise<BankFeedRuleDTO>;
    updateBankFeedRule(body: BankFeedRuleSaveDTO): IPromise<BankFeedRuleDTO>;
    deleteBankFeedRule(): IPromise<void>
    getBankFeedRuleExecutionResults(searchParams: any): IPromise<BankFeedRuleExecutionResultDTO[]>;
    reprioritizeBankFeedRules(body: number[]): IPromise<void>;
    getBankFeedRulesCount(): IPromise<number>;
}

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function BankFeedRulesApi(): IBankFeedRulesApi {
    return createActions(actions);
}
